import { createTheme } from "@mui/system";

const theme = createTheme();

const AddCreditModalStyles = () => ({
  cardContainer: {
    position: "absolute",
    // top: "50%",
    left: "50%",
    // // padding: "16px 8px",
    // transform: "translate(-50%, -50%)",
    boxShadow: 24,
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 32px)",
      maxWidth: "380px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "570px",
    },
  },
  cardBody: {
    maxWidth: 450,
    width: "100%",
    margin: "0 auto",
    // allow the form area to scroll inside the capped-height card so every
    // field (incl. the action buttons) stays reachable on small screens
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
  },
  sellerInfoContainer: {
    "& > div": {
      padding: 8,
    },
    borderBottom: `1px solid #9e9e9e96`,
  },
  inputsGridContainer: {
    "& > div": {
      padding: "8px !important",
    },
  },
  loaderBackdrop: {
    position: "absolute",
    margin: 0,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#00000040",
    height: "101%",
    width: "100%",
    cursor: "not-allowed",
    userSelect: "none",
    pointerEvents: "none",
  },
  debitInput: {
    "& label": {
      paddingTop: 4,
    },
    "& .MuiInputAdornment-root": {
      paddingTop: 8,
    },
    "& input": {
      cursor: "pointer",
      paddingTop: 16,
      paddingBottom: 8,
    },
  },
});
export default AddCreditModalStyles;
